import { adapter } from "@hg/recall-frame"
import QRCode from "qrcode"

import BGSrc from "@/assets/imgs/recall/share-base.png"
import { loadImageAnonymous } from "@/utils/load"

export const drawShareImg = async ({
    nickname,
    code,
    uid,
    defaultText,
    kv,
}: {
    uid?: string
    nickname?: string
    code?: string
    defaultText: string
    kv: string
}) => {
    const canvas = document.createElement("canvas")
    const width = 1285
    const height = 742
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext("2d")
    if (!ctx || !canvas) {
        return
    }
    ctx.clearRect(0, 0, width, height)
    const defaultFont = "sans-serif"
    let font: string
    try {
        await document.fonts.ready
        font = "ShanHaiJiGuYuZhiQingKe"
    } catch {
        font = defaultFont
    }
    ctx.textAlign = "left"
    ctx.textBaseline = "middle"
    const bg = await loadImageAnonymous(BGSrc)
    if (bg) {
        // 使用 cover 模式绘制背景图，保持宽高比并填充满画布
        drawImageCover(ctx, bg, 0, 0, width, height)
    }
    const kvImg = await loadImageAnonymous(kv)
    // const cornerImg = await loadImage(CornerSrc)
    if (kvImg) {
        // kvImg 尺寸：715 * 410，位置：left 70, top 80
        drawImageCover(ctx, kvImg, 70, 80, 715, 410)
    }

    // name 的区域定义（公共区域）
    const nameAreaX = 320
    const nameAreaY = 549
    const nameAreaWidth = 380
    const nameAreaHeight = 40
    const nameAreaCenterX = nameAreaX + nameAreaWidth / 2
    const nameAreaCenterY = nameAreaY + nameAreaHeight / 2

    // code 的区域定义
    const codeAreaX = 320
    const codeAreaY = 588
    const codeAreaWidth = 380
    const codeAreaHeight = 38
    const codeAreaCenterX = codeAreaX + codeAreaWidth / 2
    const codeAreaCenterY = codeAreaY + codeAreaHeight / 2

    if (nickname && code) {
        const name = `Dr. ${nickname}`

        // 绘制 name（在 name 区域内居中）
        ctx.font = `bold 32px ${defaultFont}`
        ctx.textAlign = "center"
        ctx.textBaseline = "middle"
        ctx.globalAlpha = 1
        ctx.fillStyle = "#ffffff"
        ctx.fillText(name, nameAreaCenterX, nameAreaCenterY)

        // 绘制 code（在 code 区域内居中）
        ctx.font = `34px ${font}`
        ctx.textAlign = "center"
        ctx.textBaseline = "middle"
        ctx.globalAlpha = 1
        ctx.fillStyle = "#ffffff"
        ctx.fillText(code, codeAreaCenterX, codeAreaCenterY)
    } else {
        const txt = defaultText

        // 使用与 name 完全相同的样式和位置
        ctx.font = `bold 32px ${defaultFont}`
        ctx.textAlign = "center"
        ctx.textBaseline = "middle"
        ctx.globalAlpha = 1
        ctx.fillStyle = "#ffffff"
        ctx.fillText(txt, nameAreaCenterX, nameAreaCenterY)
    }

    // ctx.fillStyle = "#ffffff"
    // ctx.fillRect(779, 735, 142, 138)
    const qr = await drawQRCode({
        size: 130,
        content:
            location.origin +
            location.pathname +
            `?${(
                [
                    ["page", "recall"],
                    ["invite_code", code],
                    ["share_type", "qrCode"],
                    ["source_from", adapter.source.from],
                    ["share_by", uid ? window.btoa(String(uid)) : ""],
                ] as const
            )
                .filter(([, value]) => !!value)
                .map((group) => group.join("="))
                .join("&")}`,
    })
    ctx.drawImage(qr, 172, 518, 130, 130)
    return canvas.toDataURL("image/jpeg")
}

export function drawQRCode({
    content,
    size = 200,
}: {
    content: string
    size?: number
}): Promise<HTMLCanvasElement> {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas")
        QRCode.toCanvas(canvas, content, {
            errorCorrectionLevel: "L",
            color: {
                dark: "#b06e32",
                light: "#ffffff",
            },
            width: size,
            margin: 0,
        }).then(() => resolve(canvas))
    })
}

function drawImageCover(
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
    x = 0,
    y = 0,
    width = ctx.canvas.width,
    height = ctx.canvas.height,
) {
    const canvasRatio = width / height
    const imgRatio = img.width / img.height

    let sx: number, sy: number, sw: number, sh: number

    if (imgRatio > canvasRatio) {
        // 圖片太寬，裁左右
        sh = img.height
        sw = sh * canvasRatio
        sx = (img.width - sw) / 2
        sy = 0
    } else {
        // 圖片太高，裁上下
        sw = img.width
        sh = sw / canvasRatio
        sx = 0
        sy = (img.height - sh) / 2
    }

    ctx.drawImage(img, sx, sy, sw, sh, x, y, width, height)
}
